import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { StyledLabel } from './styled.js';
import { jsx } from 'react/jsx-runtime';

function Label(props) {
  return /*#__PURE__*/jsx(StyledLabel, _extends({}, props));
}

export { Label };
